import {
  IBroadcastEmailBackEndModel,
  IBroadcastEmailFrontEndModel,
} from "../types";

export const parseToBroadcastBackEndModel = (
  values: IBroadcastEmailFrontEndModel,
): IBroadcastEmailBackEndModel => {
  const userIds = [
    ...(values.students || []),
    ...(values.parents || []),
    ...(values.agents || []),
    ...(values.schoolUsers || []),
    ...(values.serviceProviderUsers || []),
    ...(values.teachers || []),
  ].map((u) => u.id);

  const subscriberIds = (values.subscribers || []).map((s) => s.id);

  return {
    userIds,
    subscriberIds,
    subject: values.subject,
    title: values.title,
    content: values.content,
  };
};
